module.exports = __webpack_public_path__ + "img/norway-ischemic-heart-disease-female.eb2b5750.png";